<div class="modal-header">
  <h4 class="modal-title">{{ !showConfirmMessage ? 'Gestione siti web' : 'Conferma indicizzazione siti web' }}</h4>
  <button type="button" class="btn-close" i18n-aria-label aria-label="Close" 
  (click)="activeModal.dismiss('Cross click')"></button>
</div>
<form [formGroup]="urlPatternForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="mb-3">
      <label for="includePages" class="form-label">Siti web da includere <small>(una URL per linea)</small></label>
      <textarea class="form-control" id="includedUrls" rows="3" placeholder="www.example.com/nonexistent-page
*help.fakewebsite.org/missing-product" formControlName="includedUrls"></textarea>
    </div>
    <div class="mb-3">
      <label for="excludePages" class="form-label">Siti web da escludere <small>(una URL per linea)</small></label>
      <textarea class="form-control" id="excludedUrls" rows="3" placeholder="www.mysite.com/404-error-page
www.nosuchsite.net/invalid-url" formControlName="excludedUrls"></textarea>
    </div>
    @if (!showConfirmMessage) {
    <div>
      <p>Puoi utilizzare l'asterisco (<code>*</code>) per indicizzare:</p>
      <ul class="mb-0">
        <li>Un intero sito: <code>www.mysite.com/*</code></li>
        <li>Una porzione di sito: <code>www.mysite.com/faq/*</code></li>
        <li>Un intero dominio: <code>*.mysite.com</code></li>
        <li>Corrispondenza esatta: <code>"www.mysite.com/faq"</code></li>
      </ul>
      <p>
        I siti senza virgolette corrisponderanno a qualsiasi percorso successivo
        all'indirizzo specificato:
        <code>www.mysite.com/faq = www.mysite.com/faq*</code>
      </p>
    </div>
    } @else {
    <p class="mt-2">
      NOTA BENE: Non potrai eliminare le url inserite fino alla fine dell'indicizzazione (entro 24h)
    </p>
    }
  </div>
  <div class="modal-footer">
    @if (!showConfirmMessage) {
    <button type="button" class="btn btn-primary" i18n (click)="urlPatternForm.disable(); showConfirmMessage = true"
      [disabled]="urlPatternForm.invalid">Conferma</button>
    } @else {
    <app-loading-button [loading]="loading" [disabled]="loading" i18n>Conferma</app-loading-button>
    }
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()" i18n>Annulla</button>
  </div>
</form>